import React, { useEffect, useState } from "react";
import { Input, Button } from "antd";

import SearchIcon from "@/icons/Search";

const { Search } = Input;

const SearchFrom3 = ({
  defaultValue,
  placeholder,
  style,
  onSearch,
  className,
  ...rest
}) => {
  const [searchText, setSearchText] = useState(defaultValue || "");

  useEffect(() => {
    setSearchText(defaultValue || "");
  }, [defaultValue]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (!value) {
      onSearch("");
    }
  };

  return (
    <Search
      allowClear
      placeholder={placeholder}
      style={style}
      value={searchText}
      onChange={handleSearchChange}
      onSearch={onSearch}
      className={className}
      enterButton={
        <Button disabled={searchText.length < 3} type="primary">
          <SearchIcon style={{ fontSize: 14 }} />
        </Button>
      }
      {...rest}
    />
  );
};

export default SearchFrom3;
